export default __webpack_public_path__ + "static/media/matfyz-logo.d6a8dea3.svg";